export const restaurants = (state) => state.restaurants

export const restaurantsLoaded = (state) => state.restaurantsLoaded

export const getRestaurant = (state) => (id) => state.restaurants.find(x => x.id === id) || {}

export const getRestaurantMealCategories = (state) => (id) => {
    let restaurantMeals = state.restaurantsMeals[id] || []
    let array = restaurantMeals.map((restaurantMeal) => restaurantMeal?.meal_sale_elements?.meal?.category)
    return [...new Map(array.map((item) => [item["id"], item])).values()]
}

export const getRestaurantMealForCategory = (state) => (restaurant, id) => {
    let restaurantMeals = state.restaurantsMeals[restaurant] || []
    return restaurantMeals.filter((x) => x?.meal_sale_elements?.meal?.category_id === id)
} 

export const getRestaurantMealAccompaniments = (state) => (restaurant, id) => {
    let restaurantMeals = state.restaurantsMeals[restaurant] || []
    let meal = restaurantMeals.find(x => x?.meal_sale_element_id === id)
    console.log(meal)
    return meal?.meal_sale_elements?.meal?.accompaniments
}